import './utils/newrelic'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import {registerServiceWorker} from './pwa/sw_register'
import 'material-icons/iconfont/filled.css'
import 'material-icons/iconfont/outlined.css'

registerServiceWorker()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>)
